import React from 'react';
import { Link } from 'react-router-dom';
import LocalizationManager from '../../../utils/localization/localization';

const ModernHero = () => {
  return (
    <div
      id="home"
      className="relative min-h-screen bg-dark-950 overflow-hidden pt-20 pb-20 px-4 sm:px-6 lg:px-8"
    >
      {/* Animated gradient background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 w-80 h-80 bg-pink-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto">
        {/* Main content */}
        <div className="text-center space-y-8 animate-slideUp">
          {/* Badge */}
          <div className="inline-block">
            <div className="glass px-6 py-2 rounded-full">
              <p className="text-sm font-semibold text-transparent bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text">
                {LocalizationManager.t('heroInnovativeSolutions')}
              </p>
            </div>
          </div>

          {/* Main Title */}
          <div>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight">
              <span className="block text-white mb-4">{LocalizationManager.t('mainTitle')}</span>
            </h1>
          </div>

          {/* Subtitle */}
          <p className="max-w-2xl mx-auto text-xl text-dark-300 leading-relaxed">
            {LocalizationManager.t('mainDescription')}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-8">
            <Link
              to="/contactUs"
              className="group relative inline-flex items-center justify-center px-8 py-4 font-semibold text-white text-lg overflow-hidden rounded-xl transition-all duration-300"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-purple-600 via-pink-600 to-red-600 group-hover:shadow-2xl group-hover:shadow-purple-500/50 transition-all duration-300"></div>
              <span className="relative flex items-center gap-2">
                {LocalizationManager.t('heroGetStarted')}
                <svg
                  className="w-5 h-5 group-hover:translate-x-1 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </span>
            </Link>

            <button className="glass px-8 py-4 font-semibold text-white text-lg rounded-xl hover:bg-white hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center gap-2">
              {LocalizationManager.t('heroLearnMore')}
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 14l-7 7m0 0l-7-7m7 7V3"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Floating cards - decorative */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            {
              number: '01',
              titleKey: 'heroPerformance',
              descKey: 'heroPerformanceDesc'
            },
            {
              number: '02',
              titleKey: 'heroSecurity',
              descKey: 'heroSecurityDesc'
            },
            {
              number: '03',
              titleKey: 'heroScalability',
              descKey: 'heroScalabilityDesc'
            }
          ].map((feature, i) => (
            <div
              key={i}
              className="glass p-6 rounded-xl backdrop-blur-xl hover:backdrop-blur-2xl transition-all duration-300 hover:border-purple-400 hover:border-opacity-50 transform hover:scale-105 hover:-translate-y-1"
            >
              <div className="text-4xl font-bold text-purple-400 mb-3 opacity-50">
                {feature.number}
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{LocalizationManager.t(feature.titleKey)}</h3>
              <p className="text-dark-300 text-sm">{LocalizationManager.t(feature.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ModernHero;
